import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'
import dayjs from 'dayjs';
import vco from "v-click-outside"

import router from './router'
import store from '@/state/store'
import i18n from './i18n'

import BMap from "vue-baidu-map";

import "@/assets/scss/app.scss";

import { initFirebaseBackend } from './helpers/firebase/authUtils';

import { configureFakeBackend } from './helpers/fakebackend/fake-backend';
import copyrightConfig from "@/utils/config/changeCopyright.js";


import VueCropper from 'vue-cropper'

// 动态设置 TDK
const appid = copyrightConfig.AppID;
if (appid === 'wx1e899bddb256a5ca') {
  document.title = '接龙加加 - 免费微信接龙报名小程序平台';
  document.querySelector('meta[name="keywords"]').setAttribute('content', '数据统计、打卡活动助手、接龙报名、创建接龙、线上接龙、活动报名');
  document.querySelector('meta[name="description"]').setAttribute('content', '接龙加加，专业的线上接龙管理平台，致力于覆盖用户的全场景使用。无论是通用信息收集、打卡接龙，还是群内通知、调查问卷、活动报名，在这里都能一键创建。依托简洁易用的操作界面与丰富模板，创建简单，轻松生成专属接龙。高效统计与实时反馈功能，让活动管理更智能。选择接龙加加，解锁便捷接龙新体验！ ');
  const link = document.querySelector("link[rel~='icon']");
  if (link) link.href = '/favicon-jl.ico'
} else if (appid === 'wx7d8daf6d777947a2') {
  document.title = '报名管家 - 免费微信接龙报名小程序平台';
  const link = document.querySelector("link[rel~='icon']");
  if (link) link.href = '/favicon-bm.ico'
  document.querySelector('meta[name="keywords"]').setAttribute('content', '数据统计、打卡活动助手、接龙报名、报名活动、线上报名、活动报名');
  document.querySelector('meta[name="description"]').setAttribute('content', '报名管家，专业的线上接龙报名管理平台，致力于覆盖用户的全场景使用。无论是信息收集、打卡接龙，还是活动报名、调查问卷、群通知，在这里都能一键创建。依托简洁易用的操作界面与丰富模板，创建简单，轻松生成专属报名活动。高效统计与实时反馈功能，让活动管理更智能。选择报名管家，解锁便捷报名新体验！');
} else {
  document.title = '接龙加加 - 免费微信接龙报名小程序平台';
  const link = document.querySelector("link[rel~='icon']");
  if (link) link.href = '/favicon-jl.ico'
  document.querySelector('meta[name="keywords"]').setAttribute('content', '数据统计、打卡活动助手、接龙报名、创建接龙、线上接龙、活动报名');
  document.querySelector('meta[name="description"]').setAttribute('content', '接龙加加，专业的线上接龙管理平台，致力于覆盖用户的全场景使用。无论是通用信息收集、打卡接龙，还是群内通知、调查问卷、活动报名，在这里都能一键创建。依托简洁易用的操作界面与丰富模板，创建简单，轻松生成专属接龙。高效统计与实时反馈功能，让活动管理更智能。选择接龙加加，解锁便捷接龙新体验！ ');
}

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueYoutube)
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.use(VueMask)
Vue.use(VueCropper)
Vue.use(require('vue-chartist'))
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.use(BMap, {ak: 'byF65LF4eoVPkNAx72P9dLbMPq4QswaI'})
Vue.prototype.$dayjs = dayjs;
Vue.component('apexchart', VueApexCharts)

Vue.directive('removeAriaHidden', {
    bind(el) {
        let ariaEls = el.querySelectorAll('.el-radio__original');
        ariaEls.forEach((item) => {
            item.removeAttribute('aria-hidden');
        });
    }
});


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
